export const DOCUMENTS_PAGE = {
    'DOCUMENTS.PAGE.TITLE': 'Documente',
    'DOCUMENTS.ADD.MODAL.TITLE': 'Adaugă documente',
    'DOCUMENTS.DELETE_CONFIRM_MODAL.TITLE': 'Ești sigur că vrei să ștergi documentul?',
    'DOCUMENTS.DELETE_CONFIRM_MODAL.SUBTITLE1': 'Ești pe cale să ștergi acest document. Această acțiune nu poate fi reversată și presupune că:',
    'DOCUMENTS.DELETE_CONFIRM_MODAL.CONSEQUENCE1_1': 'documentul va fi disociat de orice calcul la care în acest moment este asociat'
};
